import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight, Sparkles } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/email/forgot-password", { email });
      setSent(true);
      toast.success("Vérifiez votre boîte email");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-5 h-5 text-gold" />
          <span className="font-heading text-2xl">Xook<span className="gold-text font-bold">Pub</span></span>
        </Link>
        <div className="gold-border-gradient p-8">
          {sent ? (
            <div className="text-center">
              <div className="w-14 h-14 mx-auto rounded-full bg-gold/10 text-gold flex items-center justify-center"><Mail className="w-6 h-6" /></div>
              <h1 className="mt-5 font-heading text-2xl">Email envoyé</h1>
              <p className="mt-3 text-white/65">Si un compte existe pour <span className="text-gold">{email}</span>, un lien de réinitialisation y a été envoyé. Vérifiez aussi vos spams.</p>
              <Link to="/login" data-testid="back-to-login" className="ghost-btn mt-6 inline-flex">Retour à la connexion</Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-3xl tracking-tight">Mot de passe oublié ?</h1>
              <p className="text-white/60 mt-2 text-sm">Entrez votre email, on vous envoie un lien pour le réinitialiser.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <span className="label-mono">Email</span>
                  <div className="mt-1 flex items-center gap-2 bg-obsidian-light border border-white/10 rounded-lg px-3 focus-within:border-gold/50">
                    <Mail className="w-4 h-4 text-white/40" />
                    <input data-testid="forgot-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="bg-transparent flex-1 py-3 outline-none text-sm" placeholder="vous@email.com" />
                  </div>
                </div>
                <button data-testid="forgot-submit" type="submit" disabled={loading} className="gold-btn w-full !py-3 disabled:opacity-50">
                  {loading ? "..." : "Envoyer le lien"} <ArrowRight className="w-4 h-4" />
                </button>
              </form>
              <Link to="/login" className="mt-5 block text-sm text-white/60 hover:text-gold text-center">← Retour à la connexion</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
